import {VehicleClass} from '../../interfaces/vehicles/vehicle-class';

export class VehicleClassFactory {

  /**
   *
   * @param vehicleClass
   */
  public static fromObject(vehicleClass: any): VehicleClass {

    return new class implements VehicleClass {
      id: number = vehicleClass.id;
      name: string = vehicleClass.name;
    };

  }

  /**
   *
   * @param vehicleClasses
   */
  public static fromArray(vehicleClasses: any[]): VehicleClass[] {

    return vehicleClasses.map(_vehicleClass => VehicleClassFactory.fromObject(_vehicleClass));

  }

}
